import { WeddingGiftType } from 'weddings/api/weddings'

export const WEDDING_GIFT_REGISTRY_SESSION_KEY = 'weddingGiftRegistryContext'
export const WEDDING_GIFT_REGISTRY_SLUG_QUERY_PARAM = 'weddingRegistrySlug'
export const WEDDING_GIFT_REGISTRY_CART_ID_QUERY_PARAM = 'cartId'
export const MULTI_CART_ID_QUERY_PARAM = 'multiCartId'

export const WEDDING_GIFT_REGISTRY_CART_ROUTE = '/:regionCode/weddings/:slug/gift-registry-cart'
export const WEDDING_GIFT_REGISTRY_CART_PATH_REGEXP = /\/weddings\/([^/]+)\/gift-registry-cart/
export const WEDDING_SETUP_EDIT_PATH_REGEXP = /\/weddings\/[^/]+\/edit$/

export const DISABLED_WEDDING_GIFT_TYPES = new Set([WeddingGiftType.SHOP])

export const WEDDING_GIFT_REGISTRY_NAV_ITEM_IDS = [
  'nav-link-hotels',
  'nav-link-maldives-packages',
  'nav-link-flights',
  'nav-link-tours',
  'nav-link-cruises',
  'nav-link-experiences',
  // 'nav-link-marketplace', // SHOP items are disabled for now
]

export function getWeddingGiftRegistryCartPath(slug: string) {
  return `/weddings/${slug}/gift-registry-cart`
}
